import type {
  ReviewItem,
  ReviewItemDetailResponse,
  ReviewLifecycleResponse,
} from '@exhale/contracts';
import { ReviewItemDetail } from './reviewCoreApi';

export type ReviewLifecycleServiceDependencies = {
  onlineApi: {
    getReviewItemDetail(reviewId: number, itemId: number): Promise<ReviewItemDetail>;
    submitReview(
      reviewId: number,
      vendorNotes?: string
    ): Promise<ReviewLifecycleResponse>;
    completeReview(reviewId: number): Promise<ReviewLifecycleResponse>;
    searchReviewItems(query: string, reviewId?: number): Promise<ReviewItem[]>;
  };
};

export class ReviewLifecycleService {
  constructor(private readonly deps: ReviewLifecycleServiceDependencies) {}

  async getReviewItemDetail(
    reviewId: number,
    itemId: number
  ): Promise<ReviewItemDetailResponse> {
    return this.deps.onlineApi.getReviewItemDetail(reviewId, itemId);
  }

  async submitReview(
    reviewId: number,
    vendorNotes?: string
  ): Promise<ReviewLifecycleResponse> {
    return this.deps.onlineApi.submitReview(reviewId, vendorNotes);
  }

  async completeReview(reviewId: number): Promise<ReviewLifecycleResponse> {
    return this.deps.onlineApi.completeReview(reviewId);
  }

  async searchReviewItems(query: string, reviewId?: number): Promise<ReviewItem[]> {
    return this.deps.onlineApi.searchReviewItems(query, reviewId);
  }
}
